import store from '@/store';

let domain = 'ims.test';
let upload = 'http://l.clcms.cn';

const currentDomain = window.location.hostname;
let pver = currentDomain.indexOf('clcms.cn') > -1;

if (process.env.NODE_ENV == 'production') {
    if (pver) {
        domain = 'www.clcms.cn';
        upload = 'https://www.clcms.cn';
    } else {
        domain = 'www.lk-scm.com';
        upload = 'https://www.lk-scm.com';
    }
}
/**
 * 上传图片的显示网址
 */
export const TITLE = pver ? '个人技术学习' : '联扩供应链管理系统';
export const PVER = pver;
export const UPLOAD = upload;
/**
 * 项目路由根目录
 */
export const HOST = '/';
/**
 * 项目域名
 */
export const DOMAIN = domain;

/**
 * API 接口根路径
 */
export const API_JAVA = '/java2api';

/* 注册路由 */
export function registerModel(name, model) {
    if (Object.keys(store.state).every(m => m !== name)) {
        store.registerModule(name, model);
    }
}



// WEBPACK FOOTER //
// ./src/utils/base.js